import { render, staticRenderFns } from "./pro-main.vue?vue&type=template&id=65321f34&scoped=true"
import script from "./pro-main.vue?vue&type=script&lang=js"
export * from "./pro-main.vue?vue&type=script&lang=js"
import style0 from "./pro-main.vue?vue&type=style&index=0&id=65321f34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65321f34",
  null
  
)

export default component.exports